export const STATUS_PROCESSING = 'processing';
export const STATUS_FAILED = 'failed';
export const STATUS_DECLINED = 'declined';
export const STATUS_REFUNDED = 'refunded';
export const STATUS_INITIATED = 'initiated';
export const STATUS_COMPLETED = 'completed';
export const STATUS_REJECTED = 'rejected';
export const STATUS_VOIDED = 'voided';

export const STATUS_PENDING = 'pending';
export const STATUS_PENDING_APPROVAL = 'pending_approval';
export const STATUS_APPROVED = 'approved';
export const STATUS_WITHDRAWN = 'withdrawn';

export const METHOD_CARD = 'Card';
export const METHOD_AEROPAY = 'AeroPay';
export const METHOD_PAYPAL = 'PayPal';
export const METHOD_VENMO = 'Venmo';
export const METHOD_APPLEPAY = 'ApplePay';
export const METHOD_BANK = 'Bank';

export const DISPLAY_CARD = 'Card';
export const DISPLAY_AEROPAY = 'Bank';
export const DISPLAY_PAYPAL = 'PayPal';
export const DISPLAY_VENMO = 'Venmo';
export const DISPLAY_APPLEPAY = 'Apple Pay';
export const DISPLAY_BANK = 'Bank';

export const DISPLAY_PROCESSING = 'Processing';
export const DISPLAY_FAILED = 'Failed';
export const DISPLAY_DECLINED = 'Declined';
export const DISPLAY_REFUNDED = 'Refunded';
export const DISPLAY_INITIATED = 'Initiated';
export const DISPLAY_COMPLETED = 'Completed';
export const DISPLAY_REJECTED = 'Rejected';
export const DISPLAY_VOIDED = 'Voided';

export const DISPLAY_PENDING_APPROVAL = 'Pending Approval';
export const DISPLAY_APPROVED = 'Approved';
export const DISPLAY_WITHDRAWN = 'Withdrawn';
